/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import Axios from 'axios';
import { environment } from './environments/environments';
import { AxiosRequestInterceptor } from './app/shared/http/interceptors/axios-request-interceptor';
import { AxiosResponseErrorInterceptor, AxiosResponseInterceptor } from './app/shared/http/interceptors/axios-response-interceptor';
import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios"
Axios.defaults.baseURL = environment.baseUrl;
Axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers = AxiosHeaders.from(config.headers); 
  const token = localStorage.getItem("token");
  if (token) config.headers.set("Authorization", `Bearer ${token}`);

  return config;
});
Axios.interceptors.response.use(
  (response) => AxiosResponseInterceptor(response),
  (error) => AxiosResponseErrorInterceptor(error)
);
platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));

